import { trackClick } from 'src/hooks/useAdobeTags';
import adobeTags from 'src/types/adobe-tags';
import { ButtonSecondary, IconEdit } from '@americanexpress/dls-react';
import LiteralsService from 'src/services/literals/LiteralsService';
import { DLSSize } from 'src/types/dls-size.enum';
import React from 'react';
import { goToTransactionDetails } from 'src/services/router.service';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router';
import useCurrentUser from 'src/hooks/useCurrentUser';
import Selectors from 'src/utils/selectors';

interface Props {
    transactionId: number;
    transactionName: string;
    withText?: boolean;
    className?: string;
}

export default function EditTransactionButton({
    transactionId,
    transactionName,
    withText,
    className
}: Props): JSX.Element {
    const { pathname, search } = useLocation();
    const history = useHistory();
    const { isFullPlanUser } = useCurrentUser();
    const handleOpenTransactionDetails = (): void => {
        const scrollContainer: HTMLElement = document.getElementById('scrollContainer');
        const scrollPosition: number = scrollContainer?.scrollTop;
        if (scrollPosition) {
            const searchParams: URLSearchParams = new URLSearchParams(search);
            searchParams.set('scrollPosition', scrollPosition.toString());
            history.replace(`${pathname}?${searchParams.toString()}`);
        }
        goToTransactionDetails(transactionId, isFullPlanUser, history, { from: pathname, search });
    };

    return (
        <ButtonSecondary
            role="link"
            onClick={() => {
                trackClick(pathname, adobeTags.Transactions.Row.Edit);
                handleOpenTransactionDetails();
            }}
            icon={<IconEdit />}
            aria-label={`${LiteralsService.getLiteral('TransactionsTable.edit')} ${transactionName}`}
            size={DLSSize.MEDIUM}
            data-cy={Selectors.Transactions.EDIT_TRANSACTION_BUTTON}
            className={className}
        >
            {withText && LiteralsService.getLiteral('TransactionsTable.edit')}
        </ButtonSecondary>
    );
}
